import { GlobalState } from '../../actions';

export const myPlaylistSelector = (state: GlobalState) => state.myPlaylist;

export const myPlaylistEntitySelector = (state: GlobalState) => myPlaylistSelector(state).userSongs;

export const myPlaylistPublicSelector = (state: GlobalState) => myPlaylistSelector(state).playlistPublic;